import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const RepublicOfTheCongoFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14478'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14478)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.76172 13.0667L19.0474 0H19.9998V14H4.76172V13.0667Z'
					fill='#F33630'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M15.2383 0.933334L0.952566 14H0.000185013V0H15.2383V0.933334Z'
					fill='#009643'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M21.5996 -1.44116L2.41381 18.029L-1.01162 14.7872L18.1742 -4.6829L21.5996 -1.44116Z'
					fill='#FCDF4A'
				/>
			</g>
		</svg>
	);
};

export default RepublicOfTheCongoFlagIcon;
